/* eslint-disable class-methods-use-this */
import DirectoryService from './DirectoryService';

class GoogleDirectoryService implements DirectoryService {
  readonly name = 'Google';

  // We do not have any restrictions on changing RSVP for Google.
  canChangeRsvp = () => true;

  showEmployeeDirectoryIntegrationErrorInOrgCalendarPreference = () => false;
}

export default GoogleDirectoryService;
